import { MAP_TIME, DISCRETE, LINEAR } from '../time/time';

import { formatDateTime } from '../../i18n/format';

import { axisBottom } from 'd3-axis';
import { select, create } from 'd3-selection';
import { drag } from 'd3-drag';

// use functions to get access to this scope
const handleSampleMouseOver = function(d, i) {
	select(this)
	.attr("class", "sample-mouseover")
	.attr("stroke-width", 2)			
	.attr("y1", 0)
	.attr("y2", 40);				
}
			
const handleSampleMouseOut = function(d, i) {
	select(this)
	.attr("class", null)
	.attr("stroke-width", 1)			
	.attr("y1", 0)
	.attr("y2", 20);	
}

class TimeSliderWidget {

	constructor(options) {
		const { width, height, getMap } = options;
	
		this.width = width;
		this.height = height;
		this.getMap = getMap;
	
		const svgElement = create("svg")
			.attr("width", width)
			.attr("height", height);
		this.svg = svgElement;
		
		this.samples = svgElement.append("g").attr("transform", "translate(0, 2)")
						.attr("class", "samples");
						
		this.ticks = svgElement.append("g")
		    .attr("transform", "translate(0, 22)")
		    .attr("class", "ticks");
		
		this.dragger = this.initDragger();
	}
	
	initDragger() {
		const my = this;
	
		function dragstarted(event, d) {
			const view = my.getMap().getView();
			view.beginInteraction();
		}
			
		function dragged(event, d) {
			//console.log(d);
			my.updateRelativePosition( event.x );
		}
			
		function dragended(event, d) {
			const view = my.getMap().getView();
       		view.endInteraction(); 
		}		    	
		    		 
		const dragger = this.svg.append("g")
			.attr("transform", "translate(100, 0)") 
			.attr("class", "dragger") 
 			.call(	drag()
	 				.on("start", dragstarted)
	 				.on("drag", dragged)
	 				.on("end", dragended)
	 		);
      			 		
      	dragger.append("path")
			.attr("d", "M-5.5,-5.5v10l6,5.5l6,-5.5v-10z")
			.attr("class", "drag-handle") 
			.attr("fill", "white")
			.attr("stroke", "#777")
			.attr("focusable", true)
			.attr("transform", "translate(0, 8) scale(1.05 1.25)");	
			
			return dragger;		
	}
	
	updateRelativePosition(x) {
		const map = this.getMap();
		const timeScale = this.timeScale;
		const values = this.values;
			
		const value = timeScale.invert( x );
		let indexValue = values(value);
			
		if( this.displayType === DISCRETE && indexValue % 1 < 0.1 ) {
			indexValue = Math.round(indexValue); 
		} else if( this.displayType === DISCRETE ) {
			// not at a step, unset
			indexValue = undefined;
		} 
		
		if( indexValue !== undefined )  {
			const clamped = values.invert(indexValue); 
			map.set(MAP_TIME, clamped);	
		} 
	}
	
	updateValues(displayType, values, timeScale) {
		this.displayType = displayType;
		this.values = values;
		this.timeScale = timeScale;
	
		if( timeScale) {		
			this.timeScale = timeScale.copy();
		}
				
		this.updateTimeScale();
		this.draw();
	}
	
	updateTimeScale() {
		if( this.timeScale ) {
			// 20 px margin
			this.timeScale = this.timeScale.range([20, this.width - 20]).clamp(true);
		}
	}
	
	updateSize() {
		const size = this.getMap().getSize();
		this.width = size[0] - 60;
	
		const svgElement = this.svg;
		svgElement.attr("width", this.width);
		
		this.updateTimeScale();		
		this.draw();	
	}
	
	draw() {
		if( this.timeScale ) {
			this.drawSamples();
			
			this.drawTicks();
			this.updateDragger();
		}		
	}

	drawSamples() {
		const samples = this.samples;	
		samples.selectAll("*").remove();
		
		const tickRange = this.timeScale;  
		
		const map = this.getMap();			
		const handleMouseClick = function(d, i) {
			const offsetX = select(this).attr("x1");
			
			const dateTime = tickRange.invert(offsetX);
			map.set(MAP_TIME, dateTime);	
		}	
		
		
		// draw samples
		for( let value of this.values.domain() ) {
			const position = tickRange(value);
		
			const sample = samples.append("g")
				.attr("class", "sample");
			
			sample.append("title")
			.text( formatDateTime(value) );
			
			if( Number.isNaN( position ) ){ 
				console.log(position);
			}
			
			sample.append("line")
			.attr("stroke", "currentColor")
			.attr("x1", position)
			.attr("x2", position)
			.attr("y1", 0)
			.attr("y2", 20)
			.on("mouseover", handleSampleMouseOver)
			.on("mouseout", handleSampleMouseOut)
			.on("click", handleMouseClick);		
		} 			
		
	}

	drawTicks() {
		const ticks = this.ticks;
		ticks.selectAll("*").remove();
		
		const tickRange = this.timeScale;  
	
		// draw ticks
	    ticks.call(axisBottom(tickRange).ticks()); 		
	}
	
	updateMapTime() {
		this.updateDragger();
	}
	
	updateDragger() {
	   	const map = this.getMap();
	   	
	   	if( this.getMap() != null && this.timeScale != null ) {
	    	const mapTime = map.get(MAP_TIME);
		   	const position = this.timeScale(mapTime);
	    	    	
	    	if( position ) {			
	    		this.dragger
	    		.attr("transform", `translate(${position}, 0)`);
	    	}	
		}	
	
	}
	
	node() {
		return this.svg.node();
	}
}


export { TimeSliderWidget } 